import React, { FC } from 'react';

/**
 * Shown when a server-side product preload failed after the backend's Algolia retries. Deliberately
 * NOT a client-side Algolia fallback: once the server owns the pull, a failure must be visible rather
 * than silently billed to Algolia per visitor.
 */
const ProductsLoadError: FC<{ className?: string }> = ({
  className = 'min-h-[40vh] px-24 py-60',
}) => (
  <div className={`flex items-center justify-center text-center ${className}`}>
    <p className="text-22 text-[#AE1D32] 2xl:text-26">
      Error loading products. Please refresh the page or try again later.
    </p>
  </div>
);

export default ProductsLoadError;
